const v33 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        invoicesTable: {
          ...state.options.tableViews.invoicesTable,
          'Additional Files': true,
        },
      },
    },
  };
};

export default v33;
